import { lazy } from 'react';
import { RouteObject } from 'react-router';

// project import
import Loadable from 'components/Loadable';

// render pages
const SettingsAdmin = Loadable(lazy(() => import('pages/admin/Settings')));

const AdminLocaleList = Loadable(
    lazy(() => import('pages/admin/translation/LocaleList')),
);
const AdminLocaleEdit = Loadable(
    lazy(() => import('pages/admin/translation/LocaleEdit')),
);
const AdminLocaleCreate = Loadable(
    lazy(() => import('pages/admin/translation/LocaleCreate')),
);
const AdminTranslationList = Loadable(
    lazy(() => import('pages/admin/translation/TranslationList')),
);

const AdminUserList = Loadable(lazy(() => import('pages/admin/user/List')));
const AdminUserView = Loadable(lazy(() => import('pages/admin/user/View')));
const AdminUserEdit = Loadable(lazy(() => import('pages/admin/user/Edit')));
const AdminUserCreate = Loadable(lazy(() => import('pages/admin/user/Create')));

const AdminClientList = Loadable(lazy(() => import('pages/admin/client/List')));
const AdminClientView = Loadable(lazy(() => import('pages/admin/client/Edit')));
const AdminClientCreate = Loadable(
    lazy(() => import('pages/admin/client/Create')),
);

// ==============================|| PARTNER SUB ROUTING ||============================== //
const AdminRoutes: RouteObject = {
    path: 'admin',
    children: [
        {
            path: 'settings',
            element: <SettingsAdmin />,
        },
        {
            path: 'locale',
            children: [
                {
                    index: true,
                    element: <AdminLocaleList />,
                },
                {
                    path: 'new',
                    element: <AdminLocaleCreate />,
                },
                {
                    path: ':id/edit',
                    element: <AdminLocaleEdit />,
                },
                {
                    path: ':id/:locale',
                    element: <AdminTranslationList />,
                },
            ],
        },
        {
            path: 'user',
            children: [
                {
                    index: true,
                    element: <AdminUserList />,
                },
                {
                    path: ':id',
                    element: <AdminUserView />,
                },
                {
                    path: ':id/edit',
                    element: <AdminUserEdit />,
                },
                {
                    path: 'new',
                    element: <AdminUserCreate />,
                },
            ],
        },
        {
            path: 'clients',
            children: [
                {
                    index: true,
                    element: <AdminClientList />,
                },
                {
                    path: ':id',
                    element: <AdminClientView />,
                },
                {
                    path: 'new',
                    element: <AdminClientCreate />,
                },
            ],
        },
    ],
};

export default AdminRoutes;
